<template>
    <div class="home-view">
        <section class="home-intro" aria-label="Home introduction">
            <ParticleSphere
                :heroTag="heroTagData"
            />
            <GitHubStatus />
            <StatsSection />
        </section>
        <AboutSection />
        <EcosystemSection />
        <ContactUsSection />
    </div>
</template>

<script setup>
import EcosystemSection from '@/components/home/sections/EcosystemSection.vue';
import ContactUsSection from '@/components/home/sections/ContactUsSection.vue';
import ParticleSphere from '@/components/home/ParticleSphere.vue';
import StatsSection from '@/components/home/StatsSection.vue';
import AboutSection from '@/components/home/AboutSection.vue';
import GitHubStatus from '@/components/home/GitHubStatus.vue';
import heroTags from '@/data/home.json';
import { ref } from 'vue';

const heroTagData = ref(heroTags.heroTags);
</script>

<script>
export default {
  name: 'HomeView',
};
</script>
